import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { DialogModalDS, ButtonDS, TextCapitalized } from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useCallback } from "react";
import { selectCompany } from "../../homeSlice";
import { updateVehicleDepartmentAsync } from "../../vehicles/vehiclesSlice";
import { UpdateVehicleDepartment } from "../../vehicles/vehiclesAPI";

export interface RemoveVehicleFromDepartmentModalProps {
  isVisible: boolean;
  onCloseModal: () => void;
  departmentUuid: string;
  departmentName: string;
  vehicleUuid: string | null;
}

  export const RemoveVehicleFromDepartmentModal = (props: RemoveVehicleFromDepartmentModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);

  const onRemoveVehicleFromDepartment = useCallback(() => {
    if (!company || !props.vehicleUuid || !props.departmentUuid) return;
    
    const vehiclePayload: UpdateVehicleDepartment = {
      companyUuid: company.uuid,
      vehicleUuid: props.vehicleUuid,
      departmentName: null
    };

    void dispatch(updateVehicleDepartmentAsync(vehiclePayload));
      props.onCloseModal();
  }, [company, dispatch, props])

  if (!props.vehicleUuid || !props.departmentUuid) return

  return (
    <DialogModalDS
      width={40}
      visible={props.isVisible}
      onClose={() => {
        props.onCloseModal();
      }}
      title={t("departments.modal.removeVehicle.title")}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t("departments.modal.removeVehicle.button.cancel")}
            onClick={() => {
              props.onCloseModal();
            }}
            buttonType={"secondary"}
            format={"fill"}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t("departments.modal.removeVehicle.button.confirm")}
            onClick={() => onRemoveVehicleFromDepartment()}
            buttonType={"primary"}
            format={"fill"}
          />
        ),
      }}
    >
      <StyledContent>
        <TextCapitalized>{t("departments.modal.removeVehicle.content")}</TextCapitalized>
      </StyledContent>
    </DialogModalDS>
  );
};

const StyledContent = styled.div`
  ${typographies["Body/S"]};
  color: ${colors["colors/text/lightGrey"]};
`;